import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      loginName: username,
      loginPassword: password
    }
  })
}

export function getInfo() {
  return request({
    url: '/api/login/menus',
    method: 'post'
  })
}

export function logout() {
  return request({
    url: '/api/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/api/operator/list',
    method: 'post',
    data: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/api/operator/saveOrUpdate',
    method: 'post',
    data: data
  })
}

export function deleteAdmin(data) {
  return request({
    url: '/api/operator/delete',
    method: 'post',
    data
  })
}

export function getRoleByAdmin(data) {
  return request({
    url: '/api/operator/role/list',
    method: 'post',
    data
  })
}

//分配角色
export function allocRole(data) {
  return request({
    url: '/api/operator/role/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js